import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11 * (props.wx ?? 1)}
    height={36 * (props.hx ?? 1)}
    viewBox="0 0 11 36"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.307 26.822c.14-.775.297-1.47.51-2.036.134-.353.24-.702.263-1.079.14-2.225.57-5.304.732-8.22.195-3.504.456-6.684 1.362-10.64C4.623 2.887 5.206 1.007 5.71 1c.506-.006.933 1.86.966 4.163.066 4.745.407 7.78.757 10.912.312 2.797.668 5.131.847 6.932.083.84.165 1.12.318 1.497q.079.198.205.582c.241.732 1.249 6.272.322 7.374-.615.731-1.285.941-2.258 1.545-.42.262-1.424.802-2.042.801-.733 0-1.441-.529-1.99-.868-.642-.398-1.064-.82-1.299-1.224-.721-1.243-.63-3.67-.23-5.892z"
    />
  </svg>
);
export default SvgNormal;
